import { log, supabase } from ".";

export const saveOportunidadTD = async (oportunidad) => {
  try {
    const data = await supabase.insert("sales_td", oportunidad);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    log.error("saveOportunidadTD", error);
    throw error;
  }
};
